import { EnvironmentProviders, Provider } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { httpApiErrorInterceptor } from './interceptors/http-api-error.interceptor';
import { httpLoadingInterceptor } from './interceptors/http-loading.interceptor';

const CustomPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{orange.50}',
      100: '{orange.100}',
      200: '{orange.200}',
      300: '{orange.300}',
      400: '{orange.400}',
      500: '#f57d27',
      600: '{orange.600}',
      700: '{orange.700}',
      800: '{orange.800}',
      900: '{orange.900}',
      950: '{orange.950}',
    },
  },
});

export const commonProviders: (Provider | EnvironmentProviders)[] = [
  provideAnimations(),
  providePrimeNG({
    theme: {
      preset: CustomPreset,
      options: {
        darkModeSelector: '.app-dark',
      },
    },
  }),
];

export const commonInterceptors = [httpLoadingInterceptor, httpApiErrorInterceptor];
